export var SparkJobSourceType;
(function (SparkJobSourceType) {
    SparkJobSourceType["SPARK_JOB_SOURCE_TYPE_URI"] = "URI";
    SparkJobSourceType["SPARK_JOB_SOURCE_TYPE_GIT"] = "GIT";
})(SparkJobSourceType || (SparkJobSourceType = {}));
